import React from 'react';
import { AppFooterWrapper, AppFooterText } from './styled';
import { useTranslation } from '@steinpilz/react-ux/i10n';
import { VARIABLES } from '@configs/client/constants';

export const AppFooter: React.FC = () => {
  const t = useTranslation();

  return (
    <AppFooterWrapper>
      <AppFooterText>{`${t('DamageDoc.Footer.Copyright')} ${VARIABLES.Version}(WS)-${__WEB_VERSION__}(Web)-${VARIABLES.AppEnv}`}</AppFooterText>
    </AppFooterWrapper>
  );
};
